export default __webpack_public_path__ + "static/media/outdoorReflect.25aa1328.jpg";